import { IDepartmentList, EnterpriseRoleType } from '@umu/umu-types';
import { getData } from '@umu/umu-util';
import { $window } from '@umu/umu-dom';

const shrinkTextWithEllipsis = (text: string): string => {
    return text.substring(0, 4) + '...';
}

const MAX_LEN: number = 30;
export function formatDepartmentName(
    isSample: boolean,
    eName: string,
    departmentName: string,
    id: string,
    parentDepartment: IDepartmentList[] = [],
): string {
    const names: string[] = [eName, ...parentDepartment.map(item => item.department_name)];

    if (departmentName && String(id) !== '0') {
        names.push(departmentName);
    }

    let retStr = names.join('/');

    if (isSample) {
        if (retStr.length > MAX_LEN) {
            names[0] = shrinkTextWithEllipsis(eName);
            retStr = names.join('/');

            if (retStr.length > MAX_LEN) {
                let lastDepartmentName = '';
                if (parentDepartment.length > 0) {
                   lastDepartmentName = parentDepartment[parentDepartment.length - 1].department_name || '';
                }

                if (lastDepartmentName) {
                    lastDepartmentName = shrinkTextWithEllipsis(lastDepartmentName) + '/';
                }

                const emptyHolderStr = new Array(Math.max(0, parentDepartment.length - 1)).fill('.../').join('');
                retStr = shrinkTextWithEllipsis(eName) + '/' + emptyHolderStr + lastDepartmentName + departmentName;
            }
        }
    }

    return retStr;
}

export const onAllowPermissionSwitch = (oriData: any, allowPermissionRoleList: EnterpriseRoleType[]) => {
    const isAllow = oriData && oriData.hasOwnProperty('manage_permission') && !oriData.manage_permission;
    // todo 隐患：如果没有 pageData.teacher_info，会有问题
    const enterpriseInfo: any = getData(($window.pageData as any).data, 'teacher_info', 'enterpriseInfo') || {};
    const roleType = Number(enterpriseInfo.role_type) || EnterpriseRoleType.LEARNER;
    return isAllow && !allowPermissionRoleList.includes(roleType);
}
